/**
 * jQuery private extension.
 *
 * @author Nakagawa_Michio@ogis-ri.co.jp
 */
;(function ($) {
  /**
   * スプラッシュ表示を行う.
   */
  $.fn.splash = function () {
    let $this = $(this)
    if ($this) {
      $this.fadeOut(3000)
    }
  }
  /**
   * 遅延表示を行う.
   */
  $.fn.lazyShow = function () {
    let $this = $(this)
    if ($this) {
      $this.hide().fadeIn('slow')
    }
  }
})(jQuery)

/**
 * 以下の項目上でのキーの入力を無効化する.
 *     - input 項目
 *     - （IE ,Edge対応）readonlyなtextarea
 *     - （IE ,Edge対応）ページ（document,div など）
 */
function disabledEnterKey() {
  $(document).on('keydown', function (e) {
    //Enterキーが押されたかどうか
    let is_enter_key_pressed = (e.key && e.key === 'Enter') || (e.code && e.code === 13)

    if (!is_enter_key_pressed) {
      return true
    }

    //キー処理を無効にする
    let tgt = e.target
    switch (tgt.nodeName) {
      case 'INPUT':
        return false
      //for IE11,Edge (IE11,Edgeの場合、readonlyなtextareaでのEnter操作でもsubmit処理が行われるため)
      case 'TEXTAREA':
        return $(tgt).attr('readonly') ? false : true
      //for IE11,Edge (IE11,Edgeの場合、ページ内でのEnter操作でもsubmit処理が行われるため)
      case 'BODY':
      case 'DIV':
        return false
      //for IE11 (IE11の場合、ページ内の以下の要素上で発生したkeydown eventはBODY側ではなくこちら側で補足されるため)
      case 'SPAN':
      case 'TABLE':
      case 'TD':
        return false
      default:
        return true
    }
  })
}

/**
 * ロード時の共通設定.
 */
$(function () {
  $('.splash').splash()
  $('table').lazyShow()

  disabledEnterKey()
})
